module.exports = __webpack_public_path__ + "img/deriving_context.ad1f8dc6.png";